import {
  REQUEST_CASE_INCIDENT,
  REQUEST_CASE_INCIDENT_SUCCESS,
  REQUEST_DEL_ELEMENT,
  REQUEST_DEL_ELEMENT_SUCCESS,
  REQUEST_DEL_ELEMENT_FAIL,
  REQUEST_UPDATE_CASE_INCIDENT_FAIL
} from "./actionTypes";
import {
  getCaseIncidentUrl,
  getIncidentElementUrl
} from "../../config/apiConfig";
import { parseFetchOptions } from "../user/actions";
import errors from "../../utils/errors";

const requestCaseIncident = () => ({
  type: REQUEST_CASE_INCIDENT
});

const requestCaseIncidentSucess = (payload, skipStateUpdate) => ({
  type: REQUEST_CASE_INCIDENT_SUCCESS,
  payload,
  skipStateUpdate
});

const requestUpdateCaseIncidentFail = payload => ({
  type: REQUEST_UPDATE_CASE_INCIDENT_FAIL,
  payload
});

export const fromStringToAddition = (text = "", author) => ({
  text,
  author,
  creationDateTime: new Date().toString()
});

const fromFormToIncident = ({ incident, author }) => {
  const getItemList = i =>
    i ? i.map(d => fromStringToAddition(d, author)) : [];

  return {
    ...incident,
    descriptions: getItemList(incident.descriptions),
    perpetrators: getItemList(incident.perpetrators),
    witnesses: getItemList(incident.witnesses)
  };
};

// skipStateUpdate lets a caller PATCH without merging the result into
// state.caseDetail.data.incident - used by IncidentWizard, which patches
// mid-flow (leaving step 3) but doesn't want that write to be visible yet:
// CaseDetailPage reads that same data to decide whether to keep showing the
// wizard, so an immediate update would make it look "complete" and unmount
// the wizard before step 4. The wizard re-syncs everything itself with a
// single getCaseDetail() once it's actually done.
export const updateCaseIncident =
  ({ caseId, incident, author, onFinish, skipStateUpdate }) =>
  async dispatch => {
    dispatch(requestCaseIncident());

    dispatch(
      parseFetchOptions(async options => {
        const response = await fetch(getCaseIncidentUrl(caseId), {
          method: "PATCH",
          headers: {
            ...options.headers,
            "Content-Type": "application/json"
          },
          body: JSON.stringify(incident)
        }).catch(error => {
          dispatch(requestUpdateCaseIncidentFail(error));
          if (onFinish) onFinish(false);
        });

        if (response && response.ok) {
          // Always dispatched (even when skipStateUpdate is set) because this
          // is also what resets state.caseIncident.isLoading back to false -
          // skipping it entirely left that flag stuck at true for the rest
          // of the session, which showed up as CaseIncidentsSubmit's confirm
          // dialog spinning forever on a later, unrelated submit.
          dispatch(
            requestCaseIncidentSucess(
              fromFormToIncident({ incident, author }),
              skipStateUpdate
            )
          );
          if (onFinish) onFinish(true);
        } else {
          dispatch(
            requestUpdateCaseIncidentFail(errors.responseError(response))
          );
          if (onFinish) onFinish(false);
        }
      })
    );
  };

const requestDeleteElement = () => ({
  type: REQUEST_DEL_ELEMENT
});

const requestDeleteElementSucess = payload => ({
  type: REQUEST_DEL_ELEMENT_SUCCESS,
  payload
});

const requestDeleteElementFail = () => ({
  type: REQUEST_DEL_ELEMENT_FAIL
});

export const deleteIncidentItem =
  ({ caseId, itemId, type, onFinish }) =>
  async dispatch => {
    dispatch(requestDeleteElement());

    const handleFinish = v => onFinish && onFinish(v);

    dispatch(
      parseFetchOptions(async options => {
        const response = await fetch(
          getIncidentElementUrl({ caseId, type, itemId }),
          { method: "DELETE", headers: options.headers }
        ).catch(() => null);

        if (response && response.ok) {
          dispatch(requestDeleteElementSucess({ type, itemId }));
          handleFinish(true);
        } else {
          // requestDeleteElementFail doesn't carry a payload - nothing here
          // is actually recorded either way.
          dispatch(requestDeleteElementFail(errors.responseError(response)));
          handleFinish(false);
        }
      })
    );
  };
